import {
  Container,
  ContentGroup,
  GridItem,
  Heading,
} from '@constellation/core';
import { Link } from 'components/tagging';
import styled from 'styled-components';

export const StyledContainer = styled(Container)`
  padding: 0 !important;
`;

export const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color_text_default_2} !important;
`;

export const StyledLink = styled(Link)`
  margin-top: ${({ theme }) => theme.spacing_05} !important;
  padding: 0 !important;
  @media (min-width: ${({ theme }) => theme.breakpoint_md}) {
    margin-top: 0 !important;
  }
`;

export const StyledGridItem = styled(GridItem)`
  @media (min-width: ${({ theme }) => theme.breakpoint_lg}) {
    max-width: 792px !important;
  }
`;

export const StyledInnerContentGroup = styled(ContentGroup)`
  padding: 0 !important;
  display: inline-block;
  margin-left: 12px !important;
  max-width: calc(100% - 48px);
`;

export const StyledOuterContentGroup = styled(ContentGroup)`
  padding: 0 !important;
  height: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoint_lg}) {
    min-width: 792px !important;
  }
`;
